import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AssetList } from '../assetlist/AssetList'
import get from '../helpers/Api'
import LoadingIndicator from '../loadingindicator/LoadingIndicator'
import { getEndpoint, getOwnerTerm } from '../helpers/FormatLinks'
import { MarketList } from '../assetlist/MarketList'

const FixedSearchComponent = (props) => {
    const searchSettings = props['searchSettings']
        ? props['searchSettings']
        : { minimal: false }

    const getValue = (key, def) => {
        if (searchSettings[key]) return searchSettings[key]['value']
        return def
    }

    const { t } = useTranslation('common')

    const userName = props['userName']
    const [searchResults, setSearchResults] = useState([])
    const searchName = getValue('name', null)
    const searchOwner = getValue('owner', null)
    const searchSchema = getValue('schema', null)
    const searchSearch = getValue('search_type', 'sales')
    const orderBy = getValue('order_by', 'offer')
    const orderDir = getValue('order_dir', 'ASC')
    const searchTemplateId = getValue('templateId', null)
    const searchFavorites = getValue('favorites', false)
    const [isLoading, setIsLoading] = useState(false)
    const exactSearch = getValue('exact_search', false)
    const limitIncrease = getValue('limit', 10)
    const minPrice = getValue('min_price', 0)
    const maxPrice = getValue('max_price', 0)
    const minMint = getValue('min_mint', 0)
    const maxMint = getValue('max_mint', 0)
    const attributes = getValue('attributes', '')
    const includeTubes = getValue('includeTubes', true)
    const id = props['id']
    const [isInitial, setIsInitial] = useState(true)
    const [searchDate, setSearchDate] = useState(new Date())
    const searchOffset = getValue('offset', 0)
    const currentSearchPath = []

    const searchOfferType = searchSettings['searchOfferType']
        ? searchSettings['searchOfferType']
        : 'sales'

    const searchAuthor = getValue('collection', '*')

    const searchVerified = !searchAuthor

    const getSearchResult = (result, searchPath) => {
        setIsLoading(false)
        if (
            currentSearchPath.length === 0 ||
            currentSearchPath[currentSearchPath.length - 1] === searchPath
        ) {
            setSearchResults(result)
        }

        return result
    }

    const runSearch = async (
        name,
        owner,
        collection,
        schema,
        isExactSearch,
        order,
        dir,
        search,
        offerType,
        min_price,
        max_price,
        min_mint,
        max_mint,
        templateId,
        verified,
        favorites,
        attributes,
        includeTubes,
        limit = limitIncrease,
        offset = 0,
    ) => {
        if (search === 'bulk_bundle' && !collection) return

        if (!collection || collection === '*') schema = ''

        setIsLoading(true)
        setIsInitial(false)

        let result = []

        if (limit === limitIncrease) {
            setSearchResults(result)
        }

        const endpoint = getEndpoint(search, 'assets')

        const ownerTerm = getOwnerTerm(
            ['sells', 'buys'].includes(search) ? search : endpoint,
        )

        const searchPath = `${endpoint}?term=${
            name
                ? name.includes('#') || name.includes('&') || name.includes('?')
                    ? escape(name)
                    : name
                : templateId
                ? templateId
                : ''
        }&${ownerTerm}=${owner ? owner : ''}&collection=${
            collection ? collection : ''
        }&schema=${schema ? schema : ''}&order_by=${
            order ? order : 'asset_id'
        }&order_dir=${
            dir ? dir : 'ASC'
        }&limit=${limit}&search_type=${search}&exact_search=${
            isExactSearch ? isExactSearch : false
        }&offer_type=${offerType}&min_price=${min_price}&max_price=${max_price}&min_mint=${min_mint}&max_mint=${max_mint}&offset=${offset}&verified=${verified}&favorites=${favorites}&user=${
            userName ? userName : ''
        }${includeTubes ? '' : '&include_tubes=false'}${
            attributes ? `&attributes=${attributes}` : ''
        }`

        currentSearchPath.push(searchPath)

        await get(searchPath, 'wax-api').then((result) =>
            getSearchResult(result, searchPath),
        )

        setSearchDate(new Date())
    }

    useEffect(() => {
        if (
            !isLoading &&
            isInitial &&
            searchResults.length === 0 &&
            typeof window !== 'undefined'
        ) {
            runSearch(
                searchName,
                searchOwner,
                searchAuthor,
                searchSchema,
                exactSearch,
                orderBy,
                orderDir,
                searchSearch,
                searchOfferType,
                minPrice,
                maxPrice,
                minMint,
                maxMint,
                searchTemplateId,
                searchVerified,
                searchFavorites,
                attributes,
                includeTubes,
                limitIncrease,
                0,
                true,
            )
        }
    }, [searchOffset, currentSearchPath, searchSearch])

    return (
        <div
            className={cn(
                'w-full px-0 text-left h-full m-auto flex overflow-y-auto InsideScroll',
            )}
            id="AssetSearch"
        >
            {typeof window !== 'undefined' ? (
                <>
                    {getEndpoint(searchSearch, 'assets') === 'listings' ? (
                        <MarketList
                            id={id}
                            searchDate={searchDate}
                            search={searchSearch}
                            name="SearchResults"
                            assets={
                                searchResults.length > 0 ? searchResults : []
                            }
                            onSale={true}
                            isLoading={isLoading}
                            type={getValue('preview_type', null)}
                        />
                    ) : (
                        <AssetList
                            id={id}
                            searchDate={searchDate}
                            search={searchSearch}
                            name="SearchResults"
                            assets={
                                searchResults.length > 0 ? searchResults : []
                            }
                            onSale={true}
                            isLoading={isLoading}
                            type={getValue('preview_type', null)}
                        />
                    )}
                    {isLoading && searchResults.length > 0 ? (
                        <LoadingIndicator />
                    ) : null}
                </>
            ) : null}
        </div>
    )
}

export default FixedSearchComponent
